<template>
  <div class="floating-taskbar-toggle" @click="toggleFloatingTaskBar">
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 8.11279H15.2258M8.1129 15.2257V0.999896"
        stroke="#B3B3B3"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  methods: {
    toggleFloatingTaskBar(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped>
.floating-taskbar-toggle {
  text-align: center;
  font-weight: 100;
  cursor: pointer;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 5px;
  border-radius: 50%;
  font-size: 40px;
  transition: 0.2s ease-in-out background;
  height: 44px;
  width: 46px;
  line-height: 1;
  border: 0.5px solid #b3b3b3;
  color: #b3b3b3;
}
.floating-taskbar-toggle:hover {
  color: #fff;
  background-color: #000;
  border-color: #000;
}

.floating-taskbar-toggle:hover svg path {
  stroke: #fff;
}
</style>
